import type { ChangeOrderCause } from "../constants/causes";

export type ChangeOrderStatus =
  | "reference_only"
  | "building"
  | "technical_approval"
  | "sales_approval"
  | "business_approval"
  | "approved"
  | "won"
  | "lost"
  | "canceled";

export interface ChangeOrder {
  id: string;
  number: number;
  label: string; // "CO-3"
  cause: ChangeOrderCause | "";
  causeNote: string;
  externalReference: string;
  externalUrl: string;
  status: ChangeOrderStatus;
  counts: boolean;
  referenceOnly: boolean;
  revenue: number | null;
  cost: number | null;
  hours: number | null;
  createdAt: string;
  userId: string | null;
  userName: string;
  parentProjectId: string | null;
  childProjectId: string | null;
}

export interface ChangeOrderFormValues {
  referenceOnly: boolean;
  cause: ChangeOrderCause | "";
  causeNote: string;
  externalReference: string;
  externalUrl: string;
  hours: string;
  revenue: string;
}

export const emptyChangeOrderForm: ChangeOrderFormValues = {
  referenceOnly: false,
  cause: "",
  causeNote: "",
  externalReference: "",
  externalUrl: "",
  hours: "",
  revenue: "",
};

export const isLocked = (status: ChangeOrderStatus) =>
  status === "approved" || status === "won";
